import {
  FETCH_LOAD_USER_BY_USER_ID_REQUEST,
  FETCH_LOAD_USER_BY_USER_ID_SUCCESS,
  FETCH_LOAD_USER_BY_USER_ID_FALUIRE,
  FETCH_CLEAR_USER_BY_USER_ID,
} from './loadUserByUSerIDTypes'

const initialState = {
  loading: false,
  particularUserInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOAD_USER_BY_USER_ID_REQUEST: return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_USER_BY_USER_ID_SUCCESS: return {
      ...state,
      particularUserInfo: action.payload,
      error: '',
      loading: false,
    }
    case FETCH_CLEAR_USER_BY_USER_ID: return {
      ...state,
      particularUserInfo: null,
      error: '',
      loading: false,

    }
    case FETCH_LOAD_USER_BY_USER_ID_FALUIRE: return {
      ...state,
      loading: false,
      particularUserInfo: null,
      error: action.payload,
    }
    default: return state
  }
}

export default reducer
